import { useQuery, UseQueryOptions } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios.ts"

export const useFindDocumentUrlQuery = (
  documentId: string | null,
  options?: UseQueryOptions<string>
) =>
  useQuery<string>({
    ...options,
    queryKey: ["documentUrl", documentId],
    queryFn: async () => {
      const response = await httpClient.get(`/documents/${documentId}`)
      return response.data.url
    },
    retry: false,
  })
